module.exports = __webpack_public_path__ + "static/media/icon-btn-close-dark.1fb2b123.svg";